import { useMemo } from 'react';
import type { OptionBuyingStrategy } from '@einhaus/project314-types';
import { trpcUnbatched } from '@/api/trpc';
import { DEFAULT_REQUISITIES_STALE_TIME } from '@/config/constants';
import { useAppQuery } from './useAppQuery';

/**
 * Shared query for the user's option buying strategies, using the app-standard
 * transient retry and stale time behaviour. React Query dedupes the underlying
 * request, so any number of components can use this hook without extra fetches.
 */
export const useOptionBuyingStrategies = () => {
    const query = useAppQuery({
        ...trpcUnbatched.strategy.fetchOptionBuyingStrategies.queryOptions({}),
        staleTime: DEFAULT_REQUISITIES_STALE_TIME
    });

    const strategies: OptionBuyingStrategy[] = useMemo(() => query.data?.strategies ?? [], [query.data?.strategies]);

    const strategiesById = useMemo(() => new Map(strategies.map((strategy) => [strategy.id, strategy])), [strategies]);

    return { error: query.error, isLoading: query.isLoading, strategies, strategiesById };
};
